<template>
    <div>
        <div class="modal fade" id="emojiModal" tabindex="-1" role="dialog" aria-labelledby="confirmModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="confirmModalLabel">Emoji</h5>
                        <button type="button" class="btn-close" @click="noHandler" aria-label="Close">

                        </button>
                    </div>
                    <div class="modal-body">

                        <div class="row">
                            <div class="col-5">
                                <div class="list-group">
                                    <a v-for="category in categories" href="javascript:void(0)" @click="onCategoryClick(category)"
                                       class="list-group-item list-group-item-action size-sm" :class="selectedCategory === category ? 'active' : '' ">
                                        {{category}}
                                    </a>
                                </div>
                            </div>

                            <div class="col-7">
                                <div class="d-flex flex-wrap">
                                    <div v-for="emojiData in emojiList">
                                        <div v-if="getEmoji(emojiData) !== null" :class="emojiData === selectedEmoji ? 'bg-secondary' : ''" class="pointer" style="padding: 0.1rem"
                                             @click="onEmojiSelected(emojiData)">{{getEmoji(emojiData)}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" @click="yesHandler" >Ok</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import EmojiConvertor from "emoji-js";
    import ResourcesService from "../services/ResourcesService";

    export default {
        name: 'EmojiModal',
        props: {
            yesEvent: Function,
            selectedComponent: Object
        },
        data() {
          return {
              model: webase.model,
              emoji: new EmojiConvertor(),
              selectedCategory: '',
              selectedEmoji: null,
              categories: ['Smileys & Emotion', 'People & Body', 'Food & Drink', 'Animals & Nature', 'Travel & Places',
                  'Activities', 'Objects', 'Symbols', 'Flags'],
              emojiList: [],
              currentModal: null,
              modalElement: null,
          }
        },
        mounted() {
            // add an event to trigger the parent's "noEvent" once the modal has been hidden
            // $('#emojiModal').on('hidden.bs.modal', () => {
            //     this.$emit('noEvent')
            // })
            // // show the modal
            // $('#emojiModal').modal('show')
            this.modalElement = document.getElementById('emojiModal')
            this.currentModal = new bootstrap.Modal(this.modalElement)

            this.modalElement.addEventListener('hidden.bs.modal', this.onModalHidden)

            this.currentModal.show()

            let resourcesService = new ResourcesService()
            let url = webase.utils.app.getBaseUrl() + '/resources/emoji-by-category.json?t=' + Date.now()
            resourcesService.get(url).then( (response) => {
                this.model.emojiCategories = response
                this.onCategoryClick(this.categories[0])
            })
        },
        beforeUnmount() {
            // remove the event
            // $('#emojiModal').off('hidden.bs.modal')
            this.modalElement.removeEventListener('hidden.bs.modal', this.onModalHidden)
        },
        methods: {
            onModalHidden() {
                this.$emit('noEvent')
            },
            noHandler(e) {
                // hide the modal
                this.currentModal.hide()
            },
            yesHandler(e) {
                // call the parent's "yesEvent"
                if(this.selectedEmoji && this.selectedComponent) {
                    let emojiIcon = this.emoji.replace_colons(":" + this.selectedEmoji.short_name + ":")
                    this.selectedComponent.value = this.selectedComponent.value + ' ' + emojiIcon
                }

                // hide the modal
                this.noHandler()
            },
            onCategoryClick(category) {
                this.selectedCategory = category
                this.emojiList = this.model.emojiCategories[category].sort( (a, b) => {
                    return a.sort_order - b.sort_order;
                });
            },
            getEmoji(emojiData) {
                let emojiIcon = this.emoji.replace_colons(":" + emojiData.short_name + ":")
                return emojiIcon.indexOf(':') === 0 ? null : emojiIcon
            },
            onEmojiSelected(emojiData) {
                // console.log('onEmojiSelected')
                // console.log(emojiData)
                this.selectedEmoji = emojiData
            }
        }
    }
</script>
